export const getAppVersionHeaders = (
  clientId: string,
  appVersion: string = "0.0.0"
) => {
  return {
    "x-fcd-appversion": `${clientId}@${appVersion}`,
  };
};
